import React from 'react'
import PropTypes from 'prop-types'
import EditScheduleForm from './ScheduleForm'

function EditSchedule ({ scheduledPrompt, onComplete, onCancel }) {
  return (
    <EditScheduleForm
      scheduledPrompt={scheduledPrompt}
      onComplete={onComplete}
      onCancel={onCancel}
    />
  )
}

EditSchedule.propTypes = {
  scheduledPrompt: PropTypes.object,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default EditSchedule
